
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import '@babel/polyfill';
window.Vue = require('vue');

import {
    MdAutocomplete,
    MdButton,
    MdCard,
    MdCheckbox,
    MdDialog,
    MdDialogAlert,
    MdDialogConfirm,
    MdField,
    MdIcon,
    MdList,
    MdMenu,
    MdProgress,
    MdRadio,
    MdSnackbar,
    MdSwitch,
    MdTabs,
} from 'vue-material/dist/components';
Vue.use(MdButton);
Vue.use(MdCard);
Vue.use(MdCheckbox);
Vue.use(MdDialog);
Vue.use(MdDialogAlert);
Vue.use(MdDialogConfirm);
Vue.use(MdField);
Vue.use(MdIcon);
Vue.use(MdList);
Vue.use(MdMenu);
Vue.use(MdProgress);
Vue.use(MdRadio);
Vue.use(MdSnackbar);
Vue.use(MdTabs);
Vue.use(MdSwitch);
Vue.use(MdAutocomplete);

import MdDatepicker from './components/vue-material-overrides/MdDatepicker/MdDatepicker';
Vue.component('md-datepicker', MdDatepicker);

import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import Locales from './langs/fr.js';
const store = new Vuex.Store();
Vue.use(vuexI18n.plugin, store);
            
Vue.i18n.add('fr', Locales.fr);

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

import Sticky from 'vue-sticky-directive';
Vue.use(Sticky);

require('./components');

Vue.i18n.set(window.appLocale);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);

import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

import { Carousel, Slide } from 'vue-carousel';

import VueMq from 'vue-mq';
import VueScrollTo from 'vue-scrollto';

Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        sm: 1024,
        desktop: Infinity,
    }
});
Vue.use(VueScrollTo);

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

/* add icons to the library */
library.add(fas, far, fab);

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.prototype.$waitForRef = function(refName) {
    if (this.$refs[refName]) {
        return Promise.resolve(this.$refs[refName]);
    } else {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                this.$waitForRef(refName).then(resolve).catch(reject);
            }, 100);
        });
    }
};

const app = new Vue({
    el: '#app',
    store,
    components: {
        Carousel,
        Slide
    },
    data() {
        return {
            countriesPromise: null,
            mapConfig: {
                url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                icon: ((typeof L !== 'undefined') ? L.icon({
                    iconUrl: '/imgs/leaflet-marker.webp',
                    iconAnchor: [16, 32],
                }) : null),
                defaultCenter: [52.520008, 13.404954],
            },
            navBarIsSticked: false,
            viewVideoUrl: '',
            showMainMenuLoader: true,
            showRegistrationButtonInNavbar: window.showRegistrationButtonInNavbar,
            displayRegistrationForm: false,
            showLanguageSwitcher: false,
        };
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 1024;
        },
    },
    created() {
        Vue.prototype.loadBlogCategory = (categorySlug) => {
            window.location = '/blog/' + categorySlug + '.html';
        };
    },
    mounted() {
        document.onscroll = (event) => {
            this.onStick();
        };
        this.waitForLanguageSwitcher().then(() => {
            this.showLanguageSwitcher = true;
        });
    },
    methods: {
        waitForLanguageSwitcher() {
            return new Promise((resolve, reject) => {
                if (document.getElementsByClassName('header-language-selector-real').length > 0) {
                    resolve();
                } else {
                    setTimeout(() => {
                        this.waitForLanguageSwitcher().then(resolve).catch(reject);
                    }, 100);
                }
            });
        },
        getCountries() {
            if (!this.countriesPromise) {
                this.countriesPromise = new Promise((resolve, reject) => {
                    axios.get('/api/countries?order_by=iso_code')
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch(reject);
                });
            }
            return this.countriesPromise;
        },
        onStick() {
            this.navBarIsSticked = (window.scrollY > 16);
        },
        viewVideo(url) {
            this.viewVideoUrl = url;
        },
        onHomeRegistrationtButtonVisibilityChanged(isVisible, entry) {
            this.showRegistrationButtonInNavbar = !isVisible;
        },
        scrollToTop() {
            window.scroll(0,0);
        },
        scrollToElement(el) {
            this.$scrollTo(el);
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app-fr.js